import { loadMoreButton } from './common/js/load_more_button';

document.addEventListener('DOMContentLoaded', function() {
  // 詳細を開く・閉じる
  const projectExpanders = document.querySelectorAll('[data-project-expander]');
  projectExpanders.forEach(function(projectExpander) {
    projectExpander.addEventListener('click', function() {
      const project = this.closest('[data-project-status]');
      const target = project.querySelector('[data-project-content="wrapper"]');
      if (this.dataset.projectExpander == 'opener') {
        project.setAttribute('data-project-status', 'opened');
        $(target).slideDown(300);
      } else {
        project.setAttribute('data-project-status', 'closed');
        $(target).slideUp(300);
      }
    });
  });

  // タブ切り替え
  const projectTabs = document.querySelectorAll('[data-project-tab]');
  projectTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const tabs = this.closest('[data-project-content="tabs"]');
      tabs.querySelectorAll('[data-project-tab]').forEach(function(tab) {
        tab.setAttribute('data-active', 'false');
      });
      this.setAttribute('data-active', 'true');

      const panes = this.closest('[data-project-status]').querySelectorAll('[data-project-pane');
      const target_pane = this.closest('[data-project-status]').querySelector('[data-project-pane="' + this.dataset.projectTab + '"]');
      panes.forEach(function(pane) {
        pane.setAttribute('data-active', 'false');
      });
      target_pane.setAttribute('data-active', 'true');
    });
  });

  // 続きを読む・閉じる
  const clampContents = document.querySelectorAll('[data-project-content="clamp"]');
  clampContents.forEach(function(clampContent) {
    clampContent.addEventListener('click', function() {
      const text = this.previousElementSibling;
      text.setAttribute('data-project-clamped', text.getAttribute('data-project-clamped') === 'true' ? 'false' : 'true');
    });
  });

  // 全件の○○を開く・閉じる
  loadMoreButton();
});
